import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-the-universal-process',
	templateUrl: './cig-the-universal-process.component.html',
	styleUrls: ['./cig-the-universal-process.component.scss']
})
export class CigTheUniversalProcessComponent implements OnInit {

	@Input() slides;
	@Input() foursightassets;
	@Input() author;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
